import { Component, OnInit, Output, EventEmitter, Input, SimpleChanges } from "@angular/core";
import { FormArray, FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { AuthenticationService } from "src/app/_services/authentication.service";
import { Company, PartnerFromPolicy } from "src/app/types";

@Component({
  selector: "app-multi-policies",
  templateUrl: "./multi-policies.component.html",
})
export class MultiPoliciesComponent implements OnInit {
  @Output() formReady = new EventEmitter<FormGroup>();
  @Input() policyFound: PartnerFromPolicy | undefined;
  @Input() editPoliciesJson: any;
  @Input() balance: any;
  @Input() pronto: any = 0;
  @Input() companyId: any;
  @Input() prefixOptions: any[] = [];
  @Input() allPrefixOptions: any[] = [];
  @Input() selectedPolicyPrefix: number | null = null
  @Input() selectedPolicyType: string | null = null
  @Input() selectedCompany: any | null = null
  @Input() policyNum: string | null = null

  remainingBalance: any;
  remainingPronto: number = 0;

  policies: FormArray;
  formFields: any;
  form: any;

  selectedBranch: any;

  maxAmountReached = false;
  maxAmountReachedPronto = false;
  branches: Company[] = [];


  constructor(
    private fb: FormBuilder,
    private authService: AuthenticationService
  ) {}

  async ngOnChanges(changes: SimpleChanges) {
    this.remainingBalance = this.balance;
    this.remainingPronto = this.pronto;
    if (changes['companyId']?.currentValue !== changes['companyId']?.previousValue) {
      this.getBranches();
    }
    if (changes['balance'] || changes['pronto']) {
      this.updateTotal();
    }
    if (this.companyId) {
      this.getBranches();
    }

    try {
      const companies = (await this.authService.getCompanies()) as any;
      this.branches = (
        companies[0] && companies[0].length ? companies[0] : companies
      ) as Company[];
    } catch (error) {
      console.log("🚨 ERROR", error, "🚨");
    }
  }

  getBranches() {
    let data = { id: this.companyId };
    this.authService.getBranches(data).then((res: any) => {
      if (res.length > 0) {
        this.branches = res;
      }
    });
  }

  async ngOnInit(): Promise<void> {
    const refItem = this.policyFound?.refValue;
    let policyNumber = "";
    let policyPrefix = "";
    if (refItem) {
      policyNumber = refItem.split("-")[1];
      policyPrefix = refItem.split("-")[0];
    }

    this.form = this.fb.group({
      //policyFound ? policyFound.refValue
      policies: this.fb.array([
        this.createItem(policyNumber || "", policyPrefix || ""),
      ]),
    });
    this.formReady.emit(this.form);

    if (
      this.editPoliciesJson?.policies &&
      JSON.stringify(this.editPoliciesJson?.policies) !== "{}"
    ) {
      console.log(this.editPoliciesJson);
      let length = this.editPoliciesJson.policies.length;
      console.log(length);
      if (length > 1) {
        length -= 1;
        while (length > 0) {
          this.addItem();
          length -= 1;
        }
        this.form.patchValue(this.editPoliciesJson);
      } else {
        this.form.patchValue(this.editPoliciesJson);
      }
    }
    this.updateTotal();
  }

  getControls() {
    return (this.form.get("policies") as FormArray).controls;
  }

  addItem() {
    this.policies = this.form.get("policies") as FormArray;
    this.policies.push(this.createItem());
    this.policies.updateValueAndValidity();
  }

  removeRow(index: any) {
    (<FormArray>this.form.get("policies")).removeAt(index);
    this.updateTotal();
  }

  createItem(policyNumberValue: string = "", policyPrefixValue: string = "", policyType: string = "") {
    let group = this.fb.group({});

    this.formFields = [
      {
        title: "Prefijo de Poliza",
        formControlName: "policyPrefix",
        type: "text",
      },
      {
        title: "Número de Poliza",
        formControlName: "policyNumber",
        type: "text",
      },
      {
        title: "Prima",
        formControlName: "amount",
        type: "text",
      },
      {
        title: "Compañia / Asegurador",
        formControlName: "branch",
        type: "select",
      },
      {
        title: "Pronto",
        formControlName: "pronto",
        type: "text",
      },
      {
        title: "Contract Type",
        formControlName: "contractType",
        type: "text",
      },
    ];
    let selectedPrefix: any

    if (policyPrefixValue || this.selectedPolicyPrefix) {
      const prefixFound = this.prefixOptions.find((p:any) => (p.name === policyPrefixValue || p.id === this.selectedPolicyPrefix))
      selectedPrefix = prefixFound || selectedPrefix
    }

    for (let index = 0; index < this.formFields.length; index++) {
      const field = this.formFields[index];
      const defaultValue =
        field.formControlName === "policyNumber"
        // (!this.policies) bc if its the first one = no policies yet because we are making the first one
          ? (!this.policies ? (policyNumberValue || this.policyNum) : '')
          : field.formControlName === "policyPrefix"
          ? selectedPrefix
          : field.formControlName === "contractType"
          ? (this.selectedPolicyType || policyType)
          : field.formControlName === "branch" 
          ? (this.selectedCompany ? this.selectedCompany.id : '')
          : "";
      let formControl = new FormControl(defaultValue);
      group.addControl(field.formControlName, formControl);
    }
    return group;
  }

  updateTotal() {
    if (!this.form) return;
    let policies: any = this.form.getRawValue().policies;
    this.remainingBalance = this.balance;

    for (let policy of policies) {
      this.remainingBalance -= policy.amount ? Number(policy.amount) : 0;
    }
    this.maxAmountReached = this.remainingBalance <= 0 ? true : false;
    //this.remainingBalance -= event.target.value;
    this.updateform();
  }

  updatePronto() {
    if (!this.form) return;
    let policies: any = this.form.getRawValue().policies;
    console.log(this.form.getRawValue());
    this.remainingPronto = this.pronto;

    for (let policy of policies) {
      this.remainingPronto -= policy.pronto ? Number(policy.pronto) : 0;
    }
    this.maxAmountReachedPronto = this.remainingPronto <= 0 ? true : false;
    //this.remainingBalance -= event.target.value;
    this.updateform();
  }

  prefixOptionsFiltered(contractType: string | null) {
    if (!contractType) return [];
    return this.allPrefixOptions.filter((p:any) => p.type.toUpperCase() === contractType.toUpperCase())
  }

  updateform() {
    console.log('🔥📣 chequea que no esté infiniteándo');
    (this.form.get("policies") as FormArray).updateValueAndValidity();
    this.formReady.emit(this.form);
  }
}
